import { useState } from 'react';
import { captureException } from '@pegasus/sentry';
import { RecommendationGender, Recommendation } from '@shared/types/recommendation';
import { getRecommendations } from '@client/services/api/recommendations';

export const useFetchRecommendations = (gender = RecommendationGender.FEMALE): Recommendation[] => {
    // TODO: retry strategy should be done it a more generic way, own helper or some library
    const [retry, setRetry] = useState(0);
    const [loading, setLoading] = useState(false);

    const [recommendations, setRecommendations] = useState<Recommendation[]>([]);
    if (!loading && !recommendations.length && retry < 2) {
        setLoading(true);
        setRetry(retry + 1);
        getRecommendations(gender)
            .then(newRecommendations => setRecommendations(newRecommendations || []))
            .catch(() => {
                captureException(
                    new Error(`Error on getting recomendations with gender = ${gender}`),
                );
            })
            .finally(() => setLoading(false));
    }

    return recommendations;
};
